module.exports = __webpack_public_path__ + "img/css3-brands.80cc1882.svg";